"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page",
    on: {
      scroll: _vm.handleScroll
    }
  }, [_c("div", {
    staticClass: "side-nav",
    class: {
      "is-black": _vm.currentSection >= 1 && _vm.currentSection < 5
    }
  }, _vm._l(_vm.navItems, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "nav-item",
      class: {
        active: _vm.currentSection === index
      },
      on: {
        click: function click($event) {
          return _vm.scrollToSection(index);
        }
      }
    }, [_vm._m(0, true), _c("div", {
      staticClass: "nav-text"
    }, [_vm._v(_vm._s(item))])]);
  }), 0), _c("div", {
    staticClass: "page-box section",
    attrs: {
      "data-section": "0"
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/-h-%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88banner.png"
    }
  }), _c("div", {
    staticClass: "page-title"
  }, [_vm._m(1), _c("div", {
    staticClass: "title-sub margin-bottom-70 title-sub-middle"
  }, [_vm._v("多重安全因子智能匹配车、货源，提供安全、专业、高效、优质的匹配与运输服务")]), _c("div", {
    staticClass: "title-sub title-sub-btn margin-bottom-90",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.TryNow.apply(null, arguments);
      }
    }
  }, [_vm._v("立即体验 "), _c("i", {
    staticClass: "el-icon-right"
  })])])]), _c("div", {
    staticClass: "section section-2",
    attrs: {
      "data-section": "1"
    }
  }, [_c("div", {
    staticClass: "section-2-title"
  }, [_vm._v("核心功能")]), _c("div", {
    staticClass: "feature-tabs"
  }, _vm._l(_vm.featureList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "tab-item",
      class: {
        active: _vm.activeFeature === index
      },
      on: {
        click: function click($event) {
          _vm.activeFeature = index;
        }
      }
    }, [_c("div", {
      staticClass: "icon-circle"
    }, [_c("img", {
      attrs: {
        src: _vm.activeFeature === index ? item.activeIcon : item.icon,
        alt: ""
      }
    })]), _c("div", {
      staticClass: "tab-text"
    }, [_vm._v(_vm._s(item.name))])]);
  }), 0), _c("div", {
    staticClass: "feature-content"
  }, [_c("div", {
    staticClass: "arrow left-arrow",
    on: {
      click: _vm.prevFeature
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-left"
  })]), _c("div", {
    staticClass: "arrow right-arrow",
    on: {
      click: _vm.nextFeature
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-right"
  })]), _c("div", {
    staticClass: "swiper-viewport"
  }, [_c("div", {
    staticClass: "swiper-wrapper",
    style: {
      transform: "translateX(".concat(-_vm.activeFeature * 100, "%)")
    }
  }, _vm._l(_vm.featureList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "swiper-slide",
      class: {
        "is-active": _vm.activeFeature === index
      }
    }, [_c("img", {
      staticClass: "feature-big-img",
      attrs: {
        src: item.image
      }
    })]);
  }), 0)])])]), _c("div", {
    staticClass: "section section-3",
    attrs: {
      "data-section": "2"
    }
  }, [_c("div", {
    staticClass: "case-arrow left",
    on: {
      click: _vm.prevCase
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-left"
  })]), _c("transition", {
    attrs: {
      name: "fade",
      mode: "out-in"
    }
  }, [_c("img", {
    key: _vm.currentCaseIndex,
    staticClass: "bg-img",
    attrs: {
      src: _vm.caseImages[_vm.currentCaseIndex]
    },
    on: {
      click: _vm.handleCaseImgClick
    }
  })]), _c("div", {
    staticClass: "case-arrow right",
    on: {
      click: _vm.nextCase
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-right"
  })])], 1), _vm._m(2), _vm._m(3), _vm._m(4), _c("el-dialog", {
    attrs: {
      visible: _vm.dialogVisible,
      width: "600px",
      "show-close": false,
      "close-on-click-modal": true,
      "custom-class": "logistics-contact-dialog"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "dialog-wrapper"
  }, [_c("i", {
    staticClass: "el-icon-close custom-close",
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }), _c("div", {
    staticClass: "header-spacer"
  }), _c("div", {
    staticClass: "content-panel"
  }, [_c("div", {
    staticClass: "contact-grid"
  }, _vm._l(_vm.contacts, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "contact-card"
    }, [_c("div", {
      staticClass: "region-badge"
    }, [_vm._v(_vm._s(item.region))]), _c("div", {
      staticClass: "contact-info"
    }, [_vm._v(_vm._s(item.name) + "：" + _vm._s(item.phone))])]);
  }), 0), _c("div", {
    staticClass: "hotline-card"
  }, [_c("img", {
    staticClass: "hotline-icon",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/-h-icon.png",
      alt: "客服"
    }
  }), _c("span", {
    staticClass: "hotline-text"
  }, [_vm._v("客服热线：" + _vm._s(_vm.$root.ptTel))])])])])]), _c("foot-nav")], 1);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "nav-icon"
  }, [_c("div", {
    staticClass: "dot"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-box"
  }, [_c("span", {
    staticClass: "title-item item_right"
  }, [_vm._v("物流解决方案")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section section-4",
    attrs: {
      "data-section": "3"
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E4%BA%A7%E5%93%81%E7%89%A9%E6%B5%81.png"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section section-5",
    attrs: {
      "data-section": "4"
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/-h-logo.png"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section bottom-img section-6",
    attrs: {
      "data-section": "5"
    }
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/-h-%E5%90%88%E4%BD%9C%E5%92%A8%E8%AF%A2bg.png",
      alt: "底部"
    }
  })]);
}];
render._withStripped = true;